export default function disableOnClick() {
  document.querySelectorAll('a.js-disable-on-click').forEach((link) => {
    link.addEventListener('click', () => {
      link.textContent = '…';
      window.setTimeout(function () {
        link
          .setAttribute('disabled', true)
          .setAttribute('data-method', null)
          .setAttribute('href', '#');
      }, 1);
    });
  });
}
